export function convertSlashesToHyphens(str) {
  return str.replace(/\//g, '-');
}
